export default __webpack_public_path__ + "static/media/000_intro_part2.last.8cc6ade5.webp";